export default "__VITE_ASSET__C$96cOZS__"